import React from 'react';
import { Send } from 'lucide-react';
import DayChannelPanel from './DayChannelPanel';
import telegramService, { WORLDS } from '../../services/telegramService';

/**
 * Telegram day-anchored channel — Library grid + Focus workspace of the
 * shared DayChannelPanel, pointed at the /api/telegram endpoints.
 *
 * TWO WORLDS (the Dual-Bucket System): the toggle in the Library header swaps
 * between two INDEPENDENT chronologies —
 *
 *   Conversations — the fast track. A light agent with web search only: no
 *                   tools, no RAG, ~1–3s answers.
 *   Tools         — the original full agentic PAI (unchanged).
 *
 * Each is a separate bot BE-side, so the day buckets never mix; the toggle
 * refetches with ?world=. Defaults to Tools, which is what every existing user
 * already has.
 *
 * Opening a day bucket from EITHER world lands in the normal full Focus
 * workspace: the fast track's restrictions are a property of the channel-side
 * agent, not of the Main Office continuation.
 */
const TELEGRAM_CFG = {
    key: 'telegram',
    i18nPrefix: 'telegram',
    titleKey: 'telegram',
    Icon: Send,
    iconClass: 'text-sky-500',
    dotClass: 'bg-sky-500',
    connectedClass: 'text-sky-600 dark:text-sky-400',
    service: telegramService,
    worlds: [
        { key: WORLDS.CONVERSATIONS, labelKey: 'WorldConversations' },
        { key: WORLDS.TOOLS, labelKey: 'WorldTools' },
    ],
    defaultWorld: WORLDS.TOOLS,
    worldStorageKey: 'omnis:telegram:world',
};

const TelegramPanel = (props) => <DayChannelPanel cfg={TELEGRAM_CFG} {...props} />;

export default TelegramPanel;
